import { render, staticRenderFns } from "./Addnewstore.vue?vue&type=template&id=6e9c773d&scoped=true"
import script from "./Addnewstore.vue?vue&type=script&lang=js"
export * from "./Addnewstore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c773d",
  null
  
)

export default component.exports